const bridge = () => typeof window !== "undefined" ? window.desktopOfflineFinance : null;
const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline Finance.");
  return api;
};

export const listOfflineFinanceCategories = (restaurantId, entryType) =>
  requireBridge().listCategories({ restaurantId, entryType });
export const addOfflineFinanceCategory = (restaurantId, entryType, name) =>
  requireBridge().addCategory({ restaurantId, entryType, name });
export const listOfflineFinanceEntries = (restaurantId, entryType, filters = {}) =>
  requireBridge().listEntries({ restaurantId, entryType, ...filters });
export const addOfflineFinanceEntry = (restaurantId, entryType, entry) =>
  requireBridge().addEntry({ restaurantId, entryType, ...entry });
export const deleteOfflineFinanceEntry = (restaurantId, entryId) =>
  requireBridge().deleteEntry({ restaurantId, entryId });
export const getOfflineFinanceSummary = (restaurantId, filters = {}) =>
  requireBridge().summary({ restaurantId, ...filters });
export const getOfflineFinanceProfitReport = (restaurantId, fromDate, toDate) =>
  requireBridge().profitReport({ restaurantId, fromDate, toDate });
export const getOfflineFinanceDayBookReport = (restaurantId, fromDate, toDate) =>
  requireBridge().dayBookReport({ restaurantId, fromDate, toDate });
export const getOfflineMonthlySummary = (restaurantId, year) =>
  requireBridge().monthlySummary({ restaurantId, year });
export const getOfflineSmartInsights = (restaurantId, range, limit = 50) => {
  const api = requireBridge();
  if (!api.smartInsights) {
    throw new Error("Restart the desktop app to initialize offline Business Intelligence.");
  }
  return api.smartInsights({ restaurantId, ...range, limit });
};
export const getOfflineDayWiseItemReport = (restaurantId, date) => {
  const api = requireBridge();
  if (!api.dayWiseItems) {
    throw new Error("Restart the desktop app to initialize offline item reports.");
  }
  return api.dayWiseItems({ restaurantId, date });
};
export const getOfflineMonthWiseItemReport = (restaurantId, month) => {
  const api = requireBridge();
  if (!api.monthWiseItems) {
    throw new Error("Restart the desktop app to initialize offline monthly item reports.");
  }
  return api.monthWiseItems({ restaurantId, month });
};
export const getOfflineCategorySalesReport = (restaurantId, selection) => {
  const api = requireBridge();
  if (!api.categorySalesReport) {
    throw new Error("Restart the desktop app to initialize offline category reports.");
  }
  return api.categorySalesReport({ restaurantId, ...selection });
};
export const getOfflinePaymentMethodReport = (restaurantId, date) => {
  const api = requireBridge();
  if (!api.paymentMethodReport) {
    throw new Error("Restart the desktop app to initialize offline payment reports.");
  }
  return api.paymentMethodReport({ restaurantId, date });
};
export const getOfflineCreditPaymentReport = (restaurantId, date) => {
  const api = requireBridge();
  if (!api.creditPaymentReport) {
    throw new Error("Restart the desktop app to initialize offline credit reports.");
  }
  return api.creditPaymentReport({ restaurantId, date });
};
export const getOfflineDiscountedOrdersReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.discountedOrdersReport) {
    throw new Error("Restart the desktop app to initialize offline discount reports.");
  }
  return api.discountedOrdersReport({ restaurantId, fromDate, toDate });
};
export const getOfflineSplitPaymentReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.splitPaymentReport) {
    throw new Error("Restart the desktop app to initialize offline split-payment reports.");
  }
  return api.splitPaymentReport({ restaurantId, fromDate, toDate });
};
export const getOfflineDayWiseKotReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.dayWiseKotReport) {
    throw new Error("Restart the desktop app to initialize offline KOT reports.");
  }
  return api.dayWiseKotReport({ restaurantId, fromDate, toDate });
};
export const getOfflineTaxReport = (restaurantId, filters) => {
  const api = requireBridge();
  if (!api.taxReport) {
    throw new Error("Restart the desktop app to initialize offline tax reports.");
  }
  return api.taxReport({ restaurantId, ...filters });
};

export const getOfflineCustomExcelReport = (restaurantId, reportType, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.customExcelReport) {
    throw new Error("Restart the desktop app to initialize offline custom reports.");
  }
  return api.customExcelReport({ restaurantId, reportType, fromDate, toDate });
};

export const getOfflineTableWiseSalesReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.tableWiseSalesReport) {
    throw new Error("Restart the desktop app to initialize offline table sales reports.");
  }
  return api.tableWiseSalesReport({ restaurantId, fromDate, toDate });
};

export const getOfflineTableWiseProductSalesReport = (
  restaurantId,
  fromDate,
  toDate,
  tableFilters = []
) => {
  const api = requireBridge();
  if (!api.tableWiseProductSalesReport) {
    throw new Error("Restart the desktop app to initialize offline table product reports.");
  }
  return api.tableWiseProductSalesReport({
    restaurantId,
    fromDate,
    toDate,
    tableFilters,
  });
};

export const getOfflineTopProductsReport = (restaurantId, fromDate, toDate, limit) => {
  const api = requireBridge();
  if (!api.topProductsReport) {
    throw new Error("Restart the desktop app to initialize offline top-product reports.");
  }
  return api.topProductsReport({ restaurantId, fromDate, toDate, limit });
};

export const getOfflineTopWaitersReport = (restaurantId, fromDate, toDate, limit) => {
  const api = requireBridge();
  if (!api.topWaitersReport) {
    throw new Error("Restart the desktop app to initialize offline waiter reports.");
  }
  return api.topWaitersReport({ restaurantId, fromDate, toDate, limit });
};

export const getOfflineHourlySalesReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.hourlySalesReport) {
    throw new Error("Restart the desktop app to initialize offline hourly-sales reports.");
  }
  return api.hourlySalesReport({ restaurantId, fromDate, toDate });
};

export const getOfflineCategoryPerformanceReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.categoryPerformanceReport) {
    throw new Error("Restart the desktop app to initialize offline category-performance reports.");
  }
  return api.categoryPerformanceReport({ restaurantId, fromDate, toDate, limit: 50 });
};

export const getOfflineTableUtilizationReport = (restaurantId, fromDate, toDate) => {
  const api = requireBridge();
  if (!api.tableUtilizationReport) {
    throw new Error("Restart the desktop app to initialize offline table-utilization reports.");
  }
  return api.tableUtilizationReport({ restaurantId, fromDate, toDate });
};

export const getOfflineRestaurantsOverview = (payload) => {
  const api = requireBridge();
  if (!api.restaurantsOverview) {
    throw new Error("Restart the desktop app to initialize offline Restaurant Overview.");
  }
  return api.restaurantsOverview(payload);
};
